import AdminLayout from "@/views/admin/AdminLayout.vue"
import Customers from "@/views/admin/sales/CustomerList.vue"
import CustomerInfo from "@/views/admin/sales/CustomerInfo.vue"

const routes = [
  {
    path: "/:lang/customers",
    component: AdminLayout,
    children: [
      {
        path: "",
        name: "Customers",
        meta: {
          title: "Customers.__CustomerInfo",
          requireAuth: true,
          auth: 0
        },
        props: route => ({
          ...route.params
        }),
        component: Customers
      },
      {
        path: "new",
        name: "CustomerNew",
        meta: {
          title: "Customers.__AddCustomer",
          requireAuth: true,
          auth: 0
        },
        component: CustomerInfo
      },
      {
        path: "edit/:cid",
        name: "CustomerInfo",
        meta: {
          title: "Customers.__EditCustomer",
          requireAuth: true,
          auth: 0
        },
        component: CustomerInfo,
        props: route => ({
          ...route.params
        })
      }
    ]
  }
]

export default routes
